import React from 'react';
import Section from './Section';
import Icon from './Icons';
import { PROJECTS } from '../data/projects';

export default function Projects() {
  return (
    <Section id="projects" num="03" title="Projects" subtitle="Things I've designed and built">
      <div className="projects-grid">
        {PROJECTS.map((p) => (
          <article className="card reveal" key={p.id} id={`proj-${p.id}`}>
            <div className="card__top">
              <span className="card__icon"><Icon name={p.icon} /></span>
              <span className="card__meta">{p.meta}</span>
            </div>
            <h3 className="card__title">{p.title}</h3>
            <div className="tags">{p.skills.map((s) => <span className="tag" key={s}>{s}</span>)}</div>
            <div className="card__body">
              <ul className="bullets">{p.bullets.map((b, i) => <li key={i}>{b}</li>)}</ul>
            </div>
            {p.links.length > 0 && (
              <div className="card__links">
                {p.links.map((l) => (
                  <a key={l.url} href={l.url} target="_blank" rel="noopener noreferrer" className={`btn btn--sm btn--${l.style}`}>{l.label}</a>
                ))}
              </div>
            )}
          </article>
        ))}
      </div>
    </Section>
  );
}
